module.exports = __webpack_public_path__ + "static/phase_spider-5f2721ee68294509ecbd7ee4f6531013.jpg";